module.exports = __webpack_public_path__ + "static/media/spacex.6cfb3422.PNG";


//////////////////
// WEBPACK FOOTER
// ./src/images/spacex.PNG
// module id = 90
// module chunks = 0